import { useMemo } from 'react';
import { store }  from 'index';
import { words }  from 'utils/dictionary';


const useModalTitle = () => {

  const state                    = store.getState();
  const { modalVariant }         = state.modal;
  const { lang, disabledGrades } = state.components;

  const arr      = [];
  const gradeArr = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז'];

  const disabled = disabledGrades.split('')
  for(let i = 0; i < disabled.length; i++) {
    arr.push(gradeArr[+disabled[i] - 1])
  }
  const str = arr.join(', ')

  const title = useMemo(() => {

   if ( modalVariant === 'guestModal' ) {
     return `${ words['guestAppsNotAvailable'][lang] }`
   }
   if ( modalVariant === 'logOut' ) {
       return `${ words['confirmSignOut'][lang] }`
   }
   if ( modalVariant === 'teacherUrl' ) {
       return `${ words['teacherUrlModalTitle'][lang] }`
   }
   if ( modalVariant === 'groupUrl' ) {
       return `${ words['groupUrlModalTitle1'][lang] }`
   }
   if ( modalVariant === 'whatsappRegistration' ) {
       return `${ words['registerEmail'][lang] }`
   }
   if ( modalVariant === 'teacherWarningModal' ) {
       return `${ words['lessonsWarning'][lang] }`
   }
   if ( modalVariant === 'messageSent' ) {
       return `${ words['messageSent'][lang] }`
   }
   if ( modalVariant === 'freezModal' ) {
       return `${ words['messageSent'][lang] }`
   }
   if ( modalVariant === 'generalError' ) {
      return `${ words['generalError'][lang] }`
   }
   if ( modalVariant === 'getPlus' ) {
      return `${ words['getPlus'][lang] }`
   }
   if ( modalVariant === 'getGrade' ) {
    return `${ words['getGrade'][lang] } ${ str }`
   }
   if ( modalVariant === 'freeAccessForAll' ) {
     return `${ words['freeAccessForAll'][lang] }`
   }
   if ( modalVariant === 'showFollowLink' ) {
    return `${ words['showFollowLink'][lang] }`
  }
  if ( modalVariant === 'followLinkNotFound' ) {
    return `${ words['followLinkNotFound'][lang] }`
  }
  if ( modalVariant === 'noUserVideos' ) {
    return `${ words['noUserVideos'][lang] }`
  }
  if ( modalVariant === 'userNotLoggedIn' ) {
    return `${ words['userIsNotLoggedIn'][lang] }`
  }
  
  
  
   
   
   return '';

  },[modalVariant, lang, str])

   return title

}


export default useModalTitle
